// Guaubuelo · tanda 3: animaciones de la tienda. Sin librerías.
import { getScrollEventTarget, getScrollTop } from '@theme/scroll-container';

const html = document.documentElement;
html.classList.add('gb-js');
const calma = window.matchMedia('(prefers-reduced-motion: reduce)');

// 2. Cabecera: compacta al bajar, se esconde al bajar rápido y vuelve al subir
(() => {
  if (!document.querySelector('.header-section')) return;
  let ultimo = getScrollTop();
  let ultimoT = performance.now();
  let pendiente = false;
  let inicioBajada = ultimoT;
  let inicioY = ultimo;
  const alHacerScroll = () => {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(() => {
      pendiente = false;
      const y = getScrollTop();
      const t = performance.now();
      // Bajada rápida = más de 120 px en menos de 150 ms (los saltos sueltos no cuentan)
      if (y > ultimo) {
        if (t - inicioBajada > 150) { inicioBajada = t; inicioY = ultimo; }
      } else { inicioBajada = t; inicioY = y; }
      const bajadaRapida = y - inicioY > 120 && t - inicioBajada <= 150;
      html.classList.toggle('gb-cab-compacta', y > 80);
      const abierto = document.querySelector('dialog[open], header-menu[aria-expanded="true"]');
      if (y < 160 || y < ultimo || abierto || calma.matches) html.classList.remove('gb-cab-oculta');
      else if (bajadaRapida && y > 400) html.classList.add('gb-cab-oculta');
      ultimo = y;
      ultimoT = t;
    });
  };
  const objetivo = () => getScrollEventTarget();
  let actual = objetivo();
  actual.addEventListener('scroll', alHacerScroll, { passive: true });
  window.matchMedia('(min-width: 990px)').addEventListener('change', () => {
    actual.removeEventListener('scroll', alHacerScroll);
    actual = objetivo();
    actual.addEventListener('scroll', alHacerScroll, { passive: true });
  });
})();

// 5. Paralaje suave (máx. 30 px) en las imágenes grandes de la portada, solo en pantalla
(() => {
  if (calma.matches) return;
  const capas = [...document.querySelectorAll('.gb-hero__escena, [data-gb-paralaje-auto]')];
  if (!capas.length) return;
  capas.forEach((c) => c.setAttribute('data-gb-paralaje', ''));
  const visibles = new Set();
  const io = new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? visibles.add(e.target) : visibles.delete(e.target))));
  capas.forEach((c) => io.observe(c));
  let pendiente = false;
  const pintar = () => {
    pendiente = false;
    const vh = window.innerHeight;
    for (const c of visibles) {
      const r = c.getBoundingClientRect();
      const centro = (r.top + r.height / 2 - vh / 2) / vh;
      c.style.setProperty('--gb-paralaje', `${Math.max(-30, Math.min(30, centro * -30)).toFixed(1)}px`);
    }
  };
  const pedir = () => {
    if (!pendiente && !document.hidden) {
      pendiente = true;
      requestAnimationFrame(pintar);
    }
  };
  getScrollEventTarget().addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('scroll', pedir, { passive: true });
  requestAnimationFrame(pintar);
})();

// 6. Cinta: se para al tocarla (con ratón ya se para con :hover), fuera de pantalla y con la pestaña oculta
(() => {
  document.querySelectorAll('.gb-cinta').forEach((cinta) => {
    cinta.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') cinta.classList.toggle('gb-pausa');
    });
    new IntersectionObserver(([e]) => cinta.classList.toggle('gb-fuera', !e.isIntersecting)).observe(cinta);
  });
  document.addEventListener('visibilitychange', () => html.classList.toggle('gb-oculta-pagina', document.hidden));
})();

// 8. Onda al pulsar los botones
document.addEventListener('pointerdown', (e) => {
  if (calma.matches) return;
  const boton = e.target.closest?.('.button, .button-secondary, .add-to-cart-button');
  if (!boton || boton.disabled) return;
  const r = boton.getBoundingClientRect();
  const lado = Math.max(r.width, r.height) * 2;
  const onda = document.createElement('span');
  onda.className = 'gb-onda';
  Object.assign(onda.style, { width: `${lado}px`, height: `${lado}px`, left: `${e.clientX - r.left - lado / 2}px`, top: `${e.clientY - r.top - lado / 2}px` });
  if (getComputedStyle(boton).position === 'static') boton.style.position = 'relative';
  boton.style.overflow = 'hidden';
  boton.append(onda);
  onda.addEventListener('animationend', () => onda.remove(), { once: true });
});

// 8. Cajón: líneas escalonadas al abrirse y el total anima su cambio
(() => {
  const marcar = (dialogo) => {
    dialogo.querySelectorAll('.cart-items__table-row').forEach((fila, i) => fila.style.setProperty('--gb-i', String(Math.min(i, 6))));
    dialogo.classList.remove('gb-cajon-entrando');
    void dialogo.offsetWidth;
    dialogo.classList.add('gb-cajon-entrando');
    setTimeout(() => dialogo.classList.remove('gb-cajon-entrando'), 1400);
  };
  new MutationObserver((cambios) => {
    for (const c of cambios) {
      if (c.attributeName === 'open' && c.target.matches?.('dialog[open]') && !calma.matches) {
        // Horizon pinta las líneas justo después de abrir: se reintenta unos milisegundos
        const dialogo = c.target;
        let intentos = 0;
        const probar = () => {
          if (dialogo.querySelector('.cart-items__table-row')) marcar(dialogo);
          else if (++intentos < 12) setTimeout(probar, 50);
        };
        probar();
      }
      if (c.attributeName === 'value' && c.target.matches?.('[ref="cartTotal"]') && !calma.matches) {
        c.target.animate([{ transform: 'scale(1.12)', color: 'var(--gb-sol, #f3c14b)' }, { transform: 'scale(1)' }], { duration: 500, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' });
      }
    }
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'value'] });
})();
